import { html } from 'lit';
import type { StaticPageContent } from '../../shared/content/staticPageContent.js';
import { editorSemanticText } from '../editor/editorSemanticText.js';
import {
  editorNodeClass,
  editorNodeClick,
  editorNodePointerDown,
  editorNodeStyle,
  type LandingEditorRenderOptions,
} from '../editor/landingEditorRender.js';

export const imprintHeroSection = ({
  page,
  sectionStyle,
  editor,
}: {
  page: StaticPageContent;
  sectionStyle: string;
  editor?: LandingEditorRenderOptions;
}) => {
  const heroId = 'static.impressum.hero';

  return html`
    <section
      class=${editorNodeClass(editor, heroId, 'vp-static-hero vp-imprint-hero')}
      style=${sectionStyle}
      @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, heroId, event)}
      @click=${(event: MouseEvent) => editorNodeClick(editor, heroId, event)}
    >
      <div
        class="vp-team-hero-word vp-imprint-hero-word"
        style=${`--imprint-word-characters: ${Math.max(4, page.eyebrow.length)};`}
        aria-hidden="true"
      >
        ${page.eyebrow}
      </div>
      <div class="vp-team-hero-lines vp-imprint-hero-lines" aria-hidden="true">
        <span></span><span></span><span></span>
      </div>
      <div
        class=${editorNodeClass(editor, `${heroId}.layout`, 'vp-shell vp-imprint-hero-layout')}
        style=${editorNodeStyle(editor, `${heroId}.layout`)}
        @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `${heroId}.layout`, event)}
        @click=${(event: MouseEvent) => editorNodeClick(editor, `${heroId}.layout`, event)}
      >
        <div
          class=${editorNodeClass(editor, `${heroId}.copy`, 'vp-imprint-hero-copy')}
          style=${editorNodeStyle(editor, `${heroId}.copy`)}
          @pointerdown=${(event: PointerEvent) => editorNodePointerDown(editor, `${heroId}.copy`, event)}
          @click=${(event: MouseEvent) => editorNodeClick(editor, `${heroId}.copy`, event)}
        >
          ${editorSemanticText({ editor, elementId: `${heroId}.eyebrow`, fallbackTag: 'h1', content: page.eyebrow })}
          ${editorSemanticText({ editor, elementId: `${heroId}.intro`, fallbackTag: 'p', content: page.intro })}
        </div>
      </div>
    </section>
  `;
};
